// A guest's relationId belongs to a single event, so it is stored per event
// (relationId_<eventCode>) — otherwise one event's id leaks into another event
// opened in the same tab. Keep the key format in sync with the rjs-guest-* product apps.
const relationIdKey = (eventCode: string) =>
	`relationId_${eventCode.trim()}`;

export const storeRelationId = (eventCode: string | undefined, relationId: unknown) => {
	// never store a missing id: the string "undefined" looks valid and blocks a refetch
	if (!eventCode || typeof relationId !== "string" || !relationId) return;
	sessionStorage.setItem(relationIdKey(eventCode), relationId);
	// TODO: remove once every product app reads relationId_<eventCode>; kept so
	// product apps still on the old build keep working during the rollout
	sessionStorage.setItem("relationId", relationId);
};
